export const FEATURES = {
    FRIEND_REQUESTS: "friend-requests"
}